.root {
  font-family: inherit;
}

.root-variant-body {
  color: var(--color-foreground);
}

.root-variant-muted {
  color: var(--color-muted);
}

.root-variant-caption {
  color: var(--color-muted);
}

.root-variant-error {
  color: var(--color-destructive-foreground);
}

.root-size-lg {
  font-size: 22px;
}

.root-size-base {
  font-size: 14px;
}

.root-size-sm {
  font-size: 13px;
}

.root-size-xs {
  font-size: 12px;
}

.root-weight-normal {
  font-weight: 400;
}

.root-weight-medium {
  font-weight: 500;
}

.root-weight-semibold {
  font-weight: 600;
}
